"use strict";
/**
 * DataEditLayoutForm
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var material_1 = require("@mui/material");
var Accordion_1 = __importDefault(require("@mui/material/Accordion"));
var Add_1 = __importDefault(require("@mui/icons-material/Add"));
var Remove_1 = __importDefault(require("@mui/icons-material/Remove"));
var configurationTypes_1 = require("../../shared/types/configurationTypes");
var crude_selector_1 = require("../../store/crude/crude.selector");
var commonTypes_1 = require("../../shared/types/commonTypes");
var DataEditFormElement_1 = __importDefault(require("../../screens/DataEditView/DataEditFormElement"));
var getDefaultValueForColumnType_1 = __importDefault(require("../../screens/DataEditView/util/getDefaultValueForColumnType"));
var styles_1 = require("@mui/styles");
var crudeHooks_1 = require("../../crudeHooks");
var DataTableView_1 = __importDefault(require("../DataTableView/DataTableView"));
var Accordion = material_1.styled(function (props) { return (react_1.default.createElement(Accordion_1.default, __assign({ disableGutters: true, elevation: 0, square: true }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        border: "2px solid " + theme.palette.grey.A200,
        borderRadius: '4px',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    });
});
var useStyles = styles_1.makeStyles(function (theme) { return styles_1.createStyles({
    element: {
        minHeight: theme.spacing(9),
        height: 'auto',
    },
}); });
var DataEditLayoutForm = function (props) {
    var classes = useStyles();
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    var screenDesign = react_redux_1.useSelector(crude_selector_1.getScreenDesign);
    var entity = props.entity;
    var showInPopup = props.showInPopup || screenDesign === commonTypes_1.ScreenDesign.mobile;
    var id = props.id || undefined;
    var entityEditLayout = props.entityEditLayout;
    // manage Licenses
    var integratedHTMLLicense = crudeLicense.integratedHTML.available;
    var context = react_1.useContext(crudeHooks_1.CrudeContext);
    var crudeHookProps = context.crudeHookProps;
    var TableActionElement = crudeHookProps && crudeHookProps.tableActionComponent;
    var sharedData = crudeHookProps && crudeHookProps.sharedData;
    var language = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var entitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === entity; });
    var _a = react_1.useState(), disableJoinColumns = _a[0], setDisableJoinColumns = _a[1];
    react_1.useEffect(function () {
        props.disableJoinColumns && setDisableJoinColumns(props.disableJoinColumns);
    }, [props.disableJoinColumns]);
    var _b = react_1.useState([]), editElements = _b[0], setEditElements = _b[1];
    var helperGripObject = {};
    var getInitialData = function () {
        var colData = {};
        entitySchema && entitySchema.columns.map(function (col) {
            colData[col.name] = col.nullable ? null : getDefaultValueForColumnType_1.default(col.columnType);
        });
        var initialData = {
            data: colData,
            instancePermissions: {},
            entityReferencePreviews: {},
        };
        return initialData;
    };
    var _c = react_1.default.useState(props.data || getInitialData()), data = _c[0], setData = _c[1];
    var _d = react_1.useState(), expandGroup = _d[0], setExpandGroup = _d[1];
    var _e = react_1.useState(1), completeColumns = _e[0], setCompleteColumns = _e[1];
    var _f = react_1.useState(1), completeLines = _f[0], setCompleteLines = _f[1];
    var _g = react_1.useState(0), editTab = _g[0], setEditTab = _g[1];
    react_1.useEffect(function () {
        setEditTab(props.editTab);
    }, [props.editTab]);
    react_1.useEffect(function () {
        props.data && setData(props.data);
    }, [props.data]);
    var handleChange = function (panel) { return function (event, newExpanded) {
        var obj = __assign({}, expandGroup);
        obj[panel].state = newExpanded;
        setExpandGroup(obj);
    }; };
    react_1.useEffect(function () {
        var obj = {};
        // completeColumns / Line extrahieren
        var lineCounter = 0;
        var columnCounter = 0;
        // FormGroups extrahieren >
        entityEditLayout.editTabs && entityEditLayout.editTabs.map(function (tab, index) {
            var _a;
            (_a = tab.formGroups) === null || _a === void 0 ? void 0 : _a.map(function (group) {
                if (group.position.vertical.to > lineCounter) {
                    lineCounter = group.position.vertical.to;
                }
                if (group.position.horizontal.to > columnCounter) {
                    columnCounter = group.position.horizontal.to;
                }
                obj[group.name] = {
                    initialOpen: group.initialOpen,
                    closable: group.closable,
                    state: showInPopup ? !showInPopup : group.initialOpen,
                    editTabIndex: index,
                };
            });
        });
        entityEditLayout.elements.map(function (element) {
            if ((element.editTab && entityEditLayout.editTabs && entityEditLayout.editTabs[editTab].name === element.editTab) || !element.editTab) {
                if (element.position.vertical.to > lineCounter) {
                    lineCounter = element.position.vertical.to;
                }
                if (element.position.horizontal.to > columnCounter) {
                    columnCounter = element.position.horizontal.to;
                }
            }
        });
        setExpandGroup(obj);
        // +1, weil die Lines / Columns bei 0 anfangen
        setCompleteColumns(columnCounter + 1);
        setCompleteLines(lineCounter + 1);
    }, [props.editTab]);
    var subElements = function (group) {
        var elems = [];
        var existingElem = null;
        var helperSubGridObject = {};
        var groupColumns = group.position.horizontal.to - group.position.horizontal.from + 1;
        var _loop_1 = function (l) {
            var _loop_2 = function (c) {
                if (!helperSubGridObject[l + "-" + c]) {
                    existingElem = null;
                    entityEditLayout.elements.map(function (groupElement) {
                        if ((groupElement.editTab && entityEditLayout.editTabs && entityEditLayout.editTabs[editTab].name === groupElement.editTab) || !groupElement.editTab) {
                            if (c === groupElement.position.horizontal.from && l === groupElement.position.vertical.from) {
                                existingElem = groupElement;
                            }
                        }
                    });
                    if (existingElem) {
                        for (var existL = existingElem.position.vertical.from; existL < existingElem.position.vertical.to + 1; existL += 1) {
                            for (var existC = existingElem.position.horizontal.from; existC < existingElem.position.horizontal.to + 1; existC += 1) {
                                helperSubGridObject[existL + "-" + existC] = existingElem.name;
                            }
                        }
                        var element = existingElem && (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns.find(function (col) { return col.name === existingElem.name; }));
                        var colWidth = existingElem &&
                            Math.round(12 / groupColumns * (existingElem.position.horizontal.to - existingElem.position.horizontal.from + 1));
                        // incomingReferences bestimmen > Filter setzen
                        var incomingReference = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.incomingReferences.find(function (ref) { return ref.sourceEntity === existingElem.sourceEntity && ref.sourceColumn === existingElem.sourceColumn; });
                        var embeddingEntityFilterInfo = {
                            name: entity,
                            key: (incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.sourceColumn) ? incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.sourceColumn : '',
                            value: id,
                        };
                        var embeddingEntityInfo = (incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.sourceEntity) || '';
                        if (incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.manyToManyOppositeEntityName) {
                            embeddingEntityInfo = incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.manyToManyOppositeEntityName;
                            embeddingEntityFilterInfo.joinEntity = incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.sourceEntity;
                        }
                        elems.push(react_1.default.createElement(material_1.Grid, { className: classes.element, item: true, xs: showInPopup ? 12 : colWidth, key: "group" + group.name + "line" + l + "-column" + c },
                            element &&
                                react_1.default.createElement(DataEditFormElement_1.default, { schema: element, treeViewLevel: props.treeViewLevel, disableJoinColumns: disableJoinColumns, id: id, embeddingEntityFilter: props.embeddingEntityFilter, entity: entity, data: data, fullWidth: true, onChangeData: function (newData) {
                                        props.onChangeData && props.onChangeData(__assign({}, newData));
                                    } }),
                            TableActionElement && existingElem.name === 'crudeActionElement' && id && integratedHTMLLicense &&
                                react_1.default.createElement(TableActionElement, { entity: entity, entityId: id, treeViewLevel: 0, entityData: data.data, sharedData: sharedData }),
                            existingElem.name === 'crudeIncomingReference' && incomingReference && (!showInPopup || (existingElem.layout && (configurationTypes_1.JoinEntityLayout.multiSelectDropdown === existingElem.layout || configurationTypes_1.JoinEntityLayout.multiSelectAutoComplete === existingElem.layout))) &&
                                react_1.default.createElement(DataTableView_1.default, { layout: existingElem.layout, min: existingElem.min, max: existingElem.max, entity: embeddingEntityInfo, treeViewLevel: props.treeViewLevel ? props.treeViewLevel + 1 : 1, embeddingEntityFilter: embeddingEntityFilterInfo })));
                        c += (existingElem.position.horizontal.to - existingElem.position.horizontal.from);
                    }
                    else {
                        var colWidth = Math.round(12 / groupColumns);
                        elems.push(react_1.default.createElement(material_1.Grid, { className: classes.element, item: true, xs: showInPopup ? 12 : colWidth, key: "group" + group.name + "line" + l + "-column" + c }));
                    }
                }
                out_c_1 = c;
            };
            var out_c_1;
            for (var c = group.position.horizontal.from; c <= group.position.horizontal.to; c += 1) {
                _loop_2(c);
                c = out_c_1;
            }
        };
        for (var l = group.position.vertical.from; l <= group.position.vertical.to; l += 1) {
            _loop_1(l);
        }
        return elems;
    };
    var addElements = function (existingGroup, l, c) {
        var columnElements = [];
        var colWidth = existingGroup && Math.round(12 / completeColumns * (existingGroup.position.horizontal.to - existingGroup.position.horizontal.from + 1));
        var formGroups = entityEditLayout.editTabs && entityEditLayout.editTabs[editTab].formGroups;
        var subJoinTable = false;
        var _loop_3 = function (l_1) {
            var _loop_4 = function (c_1) {
                entityEditLayout.elements.map(function (groupElement) {
                    if ((groupElement.editTab && entityEditLayout.editTabs && entityEditLayout.editTabs[editTab].name === groupElement.editTab) || !groupElement.editTab) {
                        if (c_1 === groupElement.position.horizontal.from && l_1 === groupElement.position.vertical.from) {
                            subJoinTable = groupElement.name === 'crudeIncomingReference' && groupElement.layout === configurationTypes_1.JoinEntityLayout.joinEntity;
                        }
                    }
                });
            };
            for (var c_1 = existingGroup.position.horizontal.from; c_1 <= existingGroup.position.horizontal.to; c_1 += 1) {
                _loop_4(c_1);
            }
        };
        for (var l_1 = existingGroup.position.vertical.from; l_1 <= existingGroup.position.vertical.to; l_1 += 1) {
            _loop_3(l_1);
        }
        if ((!subJoinTable && showInPopup) || !showInPopup) {
            if (formGroups && formGroups.length > 1 &&
                expandGroup && expandGroup[existingGroup.name] &&
                expandGroup[existingGroup.name].editTabIndex === editTab) {
                columnElements.push(react_1.default.createElement(material_1.Grid, { item: true, xs: showInPopup ? 12 : colWidth, key: "group" + existingGroup.name + "line" + l + "-column" + c },
                    react_1.default.createElement(Accordion, { id: existingGroup.name, expanded: expandGroup && expandGroup[existingGroup.name] && expandGroup[existingGroup.name].closable ? expandGroup[existingGroup.name].state : true, onChange: handleChange(existingGroup.name) },
                        react_1.default.createElement(material_1.AccordionSummary, { id: "AccSumline" + l + "-column" + c, expandIcon: expandGroup && expandGroup[existingGroup.name] && expandGroup[existingGroup.name].closable &&
                                react_1.default.createElement(react_1.default.Fragment, null, expandGroup[existingGroup.name].state ? react_1.default.createElement(Remove_1.default, null) : react_1.default.createElement(Add_1.default, null)) }, language && existingGroup.title &&
                            react_1.default.createElement(material_1.Typography, null, existingGroup.title[language])),
                        react_1.default.createElement(material_1.AccordionDetails, { id: "AccDetline" + l + "-column" + c },
                            react_1.default.createElement(material_1.Grid, { container: true, rowSpacing: 2, columnSpacing: { xs: 1, sm: 2, md: 3 }, key: "GridConline" + l + "-column" + c },
                                language && existingGroup.description &&
                                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                                        react_1.default.createElement(material_1.Typography, { variant: 'body2' }, existingGroup.description[language])),
                                subElements(existingGroup))))));
            }
            else {
                columnElements.push(react_1.default.createElement(material_1.Grid, { item: true, xs: showInPopup ? 12 : colWidth, key: "group" + existingGroup.name + "line" + l + "-column" + c },
                    language && existingGroup.title &&
                        react_1.default.createElement(material_1.Typography, null, existingGroup.title[language]),
                    react_1.default.createElement(material_1.Grid, { container: true, rowSpacing: 2, columnSpacing: { xs: 1, sm: 2, md: 3 }, key: "GridConline" + l + "-column" + c },
                        language && existingGroup.description &&
                            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                                react_1.default.createElement(material_1.Typography, { variant: 'body2' }, existingGroup.description[language])),
                        subElements(existingGroup))));
            }
        }
        return columnElements;
    };
    react_1.useEffect(function () {
        var _a;
        var columnElements = [];
        var existingGroup = null;
        var _loop_5 = function (l) {
            var _loop_6 = function (c) {
                if (!helperGripObject[l + "-" + c]) {
                    existingGroup = null;
                    entityEditLayout.editTabs && ((_a = entityEditLayout.editTabs[editTab].formGroups) === null || _a === void 0 ? void 0 : _a.map(function (group) {
                        if (c === group.position.horizontal.from && l === group.position.vertical.from) {
                            existingGroup = group;
                        }
                    }));
                    if (existingGroup) {
                        for (var existL = existingGroup.position.vertical.from; existL < existingGroup.position.vertical.to + 1; existL += 1) {
                            for (var existC = existingGroup.position.horizontal.from; existC < existingGroup.position.horizontal.to + 1; existC += 1) {
                                helperGripObject[existL + "-" + existC] = existingGroup.name;
                            }
                        }
                        columnElements.push(react_1.default.createElement(react_1.default.Fragment, null, addElements(existingGroup, l, c)));
                    }
                    else {
                        var colWidth = Math.round(12 / completeColumns);
                        helperGripObject[l + "-" + c] = '';
                        // TODO hier noch prüfen ob ggf. Elemente angelegt worden sind, die in keiner formGroup / Tab sind
                        // die müssen hier rein und werden per default dem ersten Tab zugeordet
                        columnElements.push(react_1.default.createElement(material_1.Grid, { item: true, xs: colWidth, key: "line" + l + "-column" + c }));
                    }
                }
            };
            for (var c = 0; c < completeColumns; c += 1) {
                _loop_6(c);
            }
        };
        for (var l = 0; l < completeLines; l += 1) {
            _loop_5(l);
        }
        setEditElements(columnElements);
    }, [expandGroup, language, data]);
    return (react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 }, editElements.map(function (elem) {
        return elem;
    })));
};
exports.default = DataEditLayoutForm;
